import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { Users, MessageSquare, Star, LayoutList, MapPin, Calendar, Clock, Mail } from "lucide-react";
import api from "@/lib/apiClient";
import { StatCard } from "@/components/dashboard/primitives";

export default function EventOverview() {
  const { event, attendeeUrl } = useOutletContext();
  const [counts, setCounts] = useState({ questions: 0, sessions: 0, feedback: 0, avg: 0, attendees: 0 });

  useEffect(() => {
    Promise.all([
      api.get(`/events/${event.id}/questions`),
      api.get(`/events/${event.id}/sessions`),
      api.get(`/events/${event.id}/feedback`),
      api.get(`/events/${event.id}/attendees`),
    ]).then(([q, s, f, a]) => {
      setCounts({ questions: q.data.length, sessions: s.data.length, feedback: f.data.count, avg: f.data.average, attendees: a.data.count });
    }).catch(() => {});
  }, [event.id]);

  const info = [
    { icon: Calendar, label: "Date", value: event.date || "—" },
    { icon: Clock, label: "Time", value: event.start_time ? `${event.start_time}${event.end_time ? " – " + event.end_time : ""}` : "—" },
    { icon: MapPin, label: "Venue", value: event.venue || event.location || "—" },
    { icon: Mail, label: "Contact", value: event.contact_info || "—" },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Users} label="Attendees" value={counts.attendees} accent />
        <StatCard icon={LayoutList} label="Sessions" value={counts.sessions} />
        <StatCard icon={MessageSquare} label="Questions" value={counts.questions} />
        <StatCard icon={Star} label="Avg feedback" value={counts.avg || "—"} />
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 rounded-xl border border-border bg-card p-6">
          <h3 className="font-display font-bold text-foreground mb-2">About this event</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{event.description || "No description provided."}</p>
          <dl className="mt-6 grid sm:grid-cols-2 gap-4">
            {info.map((i) => (
              <div key={i.label} className="flex items-start gap-3">
                <i.icon className="h-4 w-4 text-accent mt-0.5" />
                <div><dt className="text-xs text-muted-foreground">{i.label}</dt><dd className="text-sm text-foreground">{i.value}</dd></div>
              </div>
            ))}
          </dl>
        </div>

        <div className="rounded-xl border border-border bg-card p-6 flex flex-col items-center text-center">
          <h3 className="font-display font-bold text-foreground mb-1 self-start">Attendee access</h3>
          <p className="text-xs text-muted-foreground mb-4 self-start">Scan to join — no app required.</p>
          <div className="p-3 bg-white rounded-lg border border-border"><QRCodeCanvas value={attendeeUrl} size={148} level="M" /></div>
          <p className="mt-3 text-xs font-mono text-muted-foreground">Code #{event.public_code}</p>
        </div>
      </div>
    </div>
  );
}
